// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__gzXG1","submit":"Form_submit__ekXTN","submitFullWidth":"Form_submitFullWidth___XcPh","buttonWrapper":"Form_buttonWrapper__RlLOz"};